export const API_POST_ISSUES = '/issues';
export const API_GET_BANNERS = '/banners';
export const API_PUT_BANNERS_ID = (id: number): string => `/banners/${id}`;
// eslint-disable-next-line
export const API_POST_BANNERS_ID_STATUS = (id: number, status: boolean): string => {
  return `/banners/${id}/${status ? 'publish' : 'unpublish'}`;
};
